import { render, staticRenderFns } from "./PopupFormCause.vue?vue&type=template&id=4368d3fc&"
import script from "./PopupFormCause.vue?vue&type=script&lang=js&"
export * from "./PopupFormCause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports